module.exports = __webpack_public_path__ + "img/arrow.9437d9b9.svg";